const operators = [
  {
    value: "AND",
    label: "AND"
  },
  {
    value: "OR",
    label: "OR"
  }
];

export default operators;
